import { memo } from 'react';

import { CopyText, Flex, Heading, Label, Text } from '@/components/core';
import { useGetAppClientWithSecret } from '@/hooks';

import { Page } from './Page.tsx';
import { SectionCard } from './Section.tsx';
import { WorkspaceHeader } from './WorkspaceHeader.tsx';

export type APICredentialsProps = object;

// eslint-disable-next-line no-empty-pattern
const IAPICredentials = ({}: APICredentialsProps) => {
  const { data: appClient } = useGetAppClientWithSecret();

  return (
    <Page className="gap-md">
      <WorkspaceHeader>
        <Heading>API credentials</Heading>
        <Text>
          Use the credentials to authorize third party applications to access your Cradl agent.{' '}
          <span
            onClick={() => window.open('https://docs.cradl.ai/api-reference/introduction', '_blank')}
            className="cursor-pointer font-semibold underline"
          >
            Read more
          </span>{' '}
        </Text>
      </WorkspaceHeader>

      <SectionCard col>
        <Flex col className="gap-sm">
          <Label>Client ID</Label>
          <CopyText value={appClient?.clientId} data-testid="client-id" />
        </Flex>

        <Flex col className="gap-sm">
          <Label>Client Secret</Label>
          <CopyText isSensitive value={appClient?.clientSecret} data-testid="client-secret" />
        </Flex>
      </SectionCard>
    </Page>
  );
};

export const APICredentials = memo(IAPICredentials) as typeof IAPICredentials;
